import React from 'react';

const NoteSection: React.FC = ({note}) => {
  return (
    <div className="w-full bg-white/80 backdrop-blur-sm border border-gray-200/60 rounded-2xl shadow-sm px-5 py-3.5 transition-all hover:shadow-md">
      <div className="flex items-start gap-1">
        {/* Icon - properly aligned with text */}
        <div className="flex-shrink-0 pt-[3px]">
          <img src='Note.svg' className='w-4 h-4' alt="Note icon" />
        </div>
        
        {/* Two-line note content */}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 leading-relaxed tracking-wide">
            <span className="font-medium text-gray-800">Note:</span> 
            <span className="ml-1.5 text-gray-600">
              {note}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoteSection;